@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.empty {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: var(--light-100);
  min-height: calc(100vh - 160px);
  position: relative;
}

.image {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  position: absolute;
}

.cta {
  width: 100%;
  max-width: 375px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  z-index: 1;
  align-items: center;
}
